export const name = "SESSION_USER";
export const summary = `Get the email address or principal identifier of the user that's running the query.`;
export const reference = `
## SESSION_USER

Get the email address or principal identifier of the user that's running the query.

\`\`\`
SESSION_USER()
\`\`\`

### Description

For first-party users, returns the email address of the user that's running the query. For third-party users, returns the principal identifierof the user that's running the query. For more information about identities, see Principals.


### Return Data Type

\`STRING\`


### Example



\`\`\`
SELECT SESSION_USER() as user;

/*----------------------*
 | user |
 +----------------------+
 | jdoe@example.com |
 *----------------------*/
\`\`\`




source: https://cloud.google.com/bigquery/docs/reference/standard-sql/security_functions
`;
